import React, { Fragment } from 'react';
import uuid from 'uuid';
import { StyledInfoBar } from './style/StyledInfoBar';

export const InfoBar = (props) => {
	const {
		data,
		itemClassName,
		backgroundColor,
		boxShadow,
	} = props;

	return (
		<Fragment>
			<StyledInfoBar
				backgroundColor={backgroundColor}
				boxShadow={boxShadow}
			>
				<div className="row" key={uuid.v4()}>
					{
						data.map(value => (
							<div className={itemClassName || 'col'} key={uuid.v4()}>
								<p className="title">{value.title}</p>
								<p className="value">{value.value}</p>
							</div>
						))
					}
				</div>
			</StyledInfoBar>
		</Fragment>
	);
};
